import React, { useState } from 'react';
import { useLiveApp } from '../../context/LiveAppContext';

interface LoginFormProps {
 onClose?: () => void;
}

export function LoginForm({ onClose }: LoginFormProps) {
 const [email, setEmail] = useState('');
 const [password, setPassword] = useState('');
 const [isSignUp, setIsSignUp] = useState(false);
 const [isLoading, setIsLoading] = useState(false);
 const { login, signUp, error } = useLiveApp();

 const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setIsLoading(true);

  try {
   const success = isSignUp 
    ? await signUp(email, password)
    : await login(email, password);

   if (success && onClose) {
    onClose();
   }
  } catch (error) {
   console.error('Authentication failed:', error);
  } finally {
   setIsLoading(false);
  }
 };

 return (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
   <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
    <div className="flex justify-between items-center mb-4">
     <h2 className="text-xl font-bold text-gray-900">
      {isSignUp ? 'Create Account' : 'Sign In'}
     </h2>
     {onClose && (
      <button
       onClick={onClose}
       className="text-gray-500 hover:text-gray-700"
      >
       ✕
      </button>
     )}
    </div>

    <form onSubmit={handleSubmit} className="space-y-4">
     <div>
      <label htmlFor="email" className="block text-sm font-medium text-gray-700">
       Email
      </label>
      <input
       type="email"
       id="email"
       required
       value={email}
       onChange={(e) => setEmail(e.target.value)}
       className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
       placeholder="your@email.com"
      />
     </div>

     <div>
      <label htmlFor="password" className="block text-sm font-medium text-gray-700">
       Password
      </label>
      <input
       type="password"
       id="password"
       required
       value={password}
       onChange={(e) => setPassword(e.target.value)}
       className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
       placeholder={isSignUp ? "Create a secure password" : "Your password"}
       minLength={isSignUp ? 6 : undefined}
      />
     </div>

     {error && (
      <div className="text-red-600 text-sm bg-red-50 p-2 rounded">
       {error}
      </div>
     )}

     <button
      type="submit"
      disabled={isLoading}
      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
     >
      {isLoading ? (
       <div className="flex items-center space-x-2">
        <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
        <span>{isSignUp ? 'Creating Account...' : 'Signing In...'}</span>
       </div>
      ) : (
       isSignUp ? 'Create Account' : 'Sign In'
      )}
     </button>

     <div className="text-center">
      <button
       type="button"
       onClick={() => setIsSignUp(!isSignUp)}
       className="text-sm text-blue-600 hover:text-blue-500"
      >
       {isSignUp 
        ? 'Already have an account? Sign in' 
        : "Don't have an account? Sign up"
       }
      </button>
     </div>
    </form>

    <div className="mt-6 pt-6 border-t border-gray-200">
     <div className="text-sm text-gray-600">
      <p className="mb-2"><strong>Demo Credentials:</strong></p>
      <p>Email: <code className="bg-gray-100 px-1 rounded">demo@cardiovolt.ai</code></p>
      <p>Password: <code className="bg-gray-100 px-1 rounded">cardiovolt26</code></p>
     </div>
    </div>
   </div>
  </div>
 );
}